var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangleYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 108,
    viewBox: "0 0 109 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notifications/Alert-triangle",
    clipPath: "url(#clip0_268_3219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0623 8.00012L6.78136 91.6251H103.343L55.0623 8.00012ZM57.6604 4.50012C56.5056 2.50012 53.6189 2.50012 52.4642 4.50012L2.45123 91.1251C1.29653 93.1251 2.73991 95.6251 5.04931 95.6251H105.075C107.385 95.6251 108.828 93.1251 107.673 91.1251L57.6604 4.50012ZM55.0623 39.2501C56.1668 39.2501 57.0623 40.1455 57.0623 41.2501V63.7501C57.0623 64.8547 56.1668 65.7501 55.0623 65.7501C53.9577 65.7501 53.0623 64.8547 53.0623 63.7501V41.2501C53.0623 40.1455 53.9577 39.2501 55.0623 39.2501ZM55.4373 72.0001C53.5733 72.0001 52.0623 73.5112 52.0623 75.3751C52.0623 77.2391 53.5733 78.7501 55.4373 78.7501C57.3012 78.7501 58.8123 77.2391 58.8123 75.3751C58.8123 73.5112 57.3012 72.0001 55.4373 72.0001Z",
    fill: "#EFAB39"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_3219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangleYellow);
export default __webpack_public_path__ + "static/media/AlertTriangleYellow.275479248a351cf4ab3853010f1d8b18.svg";
export { ForwardRef as ReactComponent };